module.exports = __webpack_public_path__ + "static/img/2f.7c55e47.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/2f.jpg
// module id = kkHR
// module chunks = 0